/* THDB Eyewear 2027 — interacciones del tema */
(() => {
  const $ = (id) => document.getElementById(id);
  const T = window.THDB || {};
  const CODE = (T.code || 'CLUB20').toUpperCase();
  const PCT = T.pct || 20;
  const PRE = 'entrega en ' + (T.pre || '15 a 20 días');
  const ls = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    del(k) { try { localStorage.removeItem(k); } catch (e) {} }
  };
  const soles = (cents) => 'S/ ' + (cents / 100).toLocaleString('es-PE', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
  const ico = (n, c = 'i') => `<svg class="${c}"><use href="#i-${n}"/></svg>`;
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- bolsa (Ajax Cart API) ---------- */
  let cart = null, lastF = null;
  const code = () => ls.get('thdb-code');

  async function fetchCart() {
    const r = await fetch(T.routes.cart, { headers: { Accept: 'application/json' } });
    cart = await r.json();
    renderBag();
    return cart;
  }

  function renderBag() {
    if (!cart) return;
    const n = cart.item_count;
    document.querySelectorAll('[data-count]').forEach((b) => { b.textContent = n; b.hidden = !n; });
    const lines = $('lines');
    if (lines) {
      lines.innerHTML = n ? cart.items.map((it) => `<li class="line"><span class="th">${it.image ? `<img src="${it.image + (it.image.includes('?') ? '&' : '?') + 'width=200'}" alt="">` : ''}</span><span><b>${esc(it.product_title)}</b><span>${it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) : ''}</span>${it.properties && it.properties.Preventa ? `<span class="pre">Preventa · ${esc(it.properties.Preventa)}</span>` : '<br>'}<button type="button" data-rm="${it.key}">Quitar</button></span><b class="num">${soles(it.final_line_price)}</b></li>`).join('')
        : `<li class="dempty"><b>Tu bolsa está vacía</b><span>Elige tus lentes y vuelve aquí para pagar.</span><a class="btn btn-dark" href="/collections/lentes-de-sol">Ver lentes de sol</a></li>`;
    }
    const sub = cart.items_subtotal_price ?? cart.total_price;
    const c = code();
    const disc = c ? Math.round(sub * PCT / 100) : 0;
    const ship = n ? (T.ship || 0) : 0;
    if ($('sSub')) {
      $('sSub').textContent = soles(sub);
      $('sDiscRow').hidden = !disc;
      $('sDiscLbl').textContent = `Club ${PCT}% (${c || ''})`;
      $('sDisc').textContent = '−' + soles(disc);
      $('sTot').textContent = soles(sub - disc + ship);
    }
    if (c && $('codeIn') && !$('codeIn').value) $('codeIn').value = c;
    const co = $('checkout');
    if (co) {
      co.href = c ? `/discount/${encodeURIComponent(c)}?redirect=/checkout` : '/checkout';
      co.toggleAttribute('aria-disabled', !n);
    }
    const f = $('fcta');
    if (f) {
      $('fctaTot').textContent = soles(sub - disc);
      const open = $('drawer') && $('drawer').classList.contains('open');
      f.classList.toggle('show', n > 0 && !open && !document.body.classList.contains('t-cart'));
      document.body.classList.toggle('fcta-on', n > 0);
    }
  }

  function openBag() {
    const d = $('drawer'); if (!d) return;
    lastF = document.activeElement;
    d.classList.add('open'); $('scrim').classList.add('open');
    d.removeAttribute('inert'); d.setAttribute('aria-hidden', 'false');
    $('fcta') && $('fcta').classList.remove('show');
    setTimeout(() => $('closeBag').focus(), 60);
    if (!cart) fetchCart(); else renderBag();
  }
  function closeBag() {
    const d = $('drawer'); if (!d || !d.classList.contains('open')) return;
    d.classList.remove('open'); $('scrim').classList.remove('open');
    d.setAttribute('inert', ''); d.setAttribute('aria-hidden', 'true');
    renderBag();
    lastF && lastF.focus && lastF.focus();
  }

  function flyFrom(el, img) {
    if (RM || !el || !img) return;
    const bagBtn = [...document.querySelectorAll('[data-bag]')].find((b) => b.offsetParent);
    if (!bagBtn) return;
    const a = el.getBoundingClientRect(), b = bagBtn.getBoundingClientRect();
    const f = document.createElement('div'); f.className = 'fly';
    f.innerHTML = `<img src="${img}" alt="">`;
    f.style.left = a.left + a.width / 2 - 35 + 'px'; f.style.top = a.top + a.height / 2 - 35 + 'px';
    document.body.appendChild(f);
    requestAnimationFrame(() => {
      f.style.transform = `translate(${b.left + b.width / 2 - (a.left + a.width / 2)}px,${b.top + b.height / 2 - (a.top + a.height / 2)}px) scale(.3)`;
      f.style.opacity = '.2';
    });
    setTimeout(() => { f.remove(); bagBtn.classList.add('bump'); setTimeout(() => bagBtn.classList.remove('bump'), 340); }, 660);
  }

  async function addVariant(id, btn, img, thenOpen, pre) {
    if (cart && cart.items.some((it) => it.variant_id == id)) { openBag(); return false; }
    if (btn) { btn.disabled = true; }
    try {
      const r = await fetch(T.routes.add, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [pre ? { id: +id, quantity: 1, properties: { Preventa: PRE } } : { id: +id, quantity: 1 }] }) });
      const j = await r.json();
      if (!r.ok) {
        const msg = (j && (j.description || j.message)) || 'No pudimos agregarlo.';
        if (btn) { btn.disabled = false; }
        toast(/stock|disponible|available/i.test(msg) ? 'Ese modelo ya no tiene stock. Es pieza única.' : msg);
        await fetchCart();
        return false;
      }
      flyFrom(btn, img);
      if (btn && btn.classList.contains('add')) { btn.classList.add('done'); btn.innerHTML = ico('check') + '<span class="t">En tu bolsa</span>'; }
      await fetchCart();
      if (thenOpen) openBag();
      return true;
    } catch (e) {
      if (btn) btn.disabled = false;
      toast('Sin conexión. Intenta de nuevo.');
      return false;
    }
  }

  function toast(msg) {
    let t = $('thdbToast');
    if (!t) { t = document.createElement('p'); t.id = 'thdbToast'; t.setAttribute('role', 'status'); t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('show'), 3200);
  }

  async function removeLine(key) {
    await fetch(T.routes.change, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
    await fetchCart();
    document.querySelectorAll('.add.done').forEach((b) => { b.classList.remove('done'); b.disabled = false; b.innerHTML = ico('plus') + `<span class="t">${b.dataset.pre === '1' ? 'Preventa' : 'Agregar'}</span>`; });
  }

  async function applyCode(v) {
    ls.set('thdb-code', v);
    try { await fetch(T.routes.update, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: v }) }); } catch (e) {}
    renderBag();
  }

  /* ---------- clics globales ---------- */
  document.addEventListener('click', (e) => {
    const ad = e.target.closest('button[data-add]');
    if (ad) { e.preventDefault(); if (ad.classList.contains('done')) { openBag(); return; } addVariant(ad.dataset.add, ad, ad.dataset.img, false, ad.dataset.pre === '1'); return; }
    const rm = e.target.closest('[data-rm]');
    if (rm) { e.preventDefault(); removeLine(rm.dataset.rm); return; }
    if (e.target.closest('[data-bag]')) { if (!$('drawer')) return; e.preventDefault(); openBag(); return; }
    if (e.target.closest('[data-join]')) { e.preventDefault(); openJoin(); return; }
    const co = e.target.closest('#checkout');
    if (co && co.hasAttribute('aria-disabled')) { e.preventDefault(); return; }
  });
  $('closeBag') && ($('closeBag').onclick = closeBag);
  $('scrim') && ($('scrim').onclick = closeBag);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeBag(); });

  $('codeForm') && $('codeForm').addEventListener('submit', (e) => {
    e.preventDefault();
    const v = $('codeIn').value.trim().toUpperCase();
    if (!v) { $('codeNote').textContent = 'Escribe tu código.'; return; }
    if (v === CODE) { applyCode(v); $('codeNote').textContent = `Código aplicado: ${PCT}% de descuento. Se confirma al pagar.`; }
    else { ls.del('thdb-code'); $('codeNote').textContent = 'Ese código no existe. Revisa que esté bien escrito.'; renderBag(); }
  });

  /* ---------- pop-up del club ---------- */
  const modal = $('clubModal');
  function openJoin() {
    if (!modal || modal.open) return;
    modal.showModal();
    setTimeout(() => { const f = $('jDone') || $('jName'); f && f.focus(); }, 50);
    ls.set('thdb-club-seen', '1');
  }
  if (modal) {
    $('mClose').onclick = () => modal.close();
    modal.addEventListener('click', (e) => { if (e.target === modal) modal.close(); });
    const setErr = (id, msg) => { const el = $(id); el && el.setAttribute('aria-invalid', msg ? 'true' : 'false'); const er = $(id + 'Err'); if (er) er.textContent = msg || ''; };
    const form = $('joinForm');
    form && form.addEventListener('submit', (e) => {
      if (!$('jName')) return;
      let first = null;
      const name = $('jName').value.trim(), mail = $('jMail'), tel = $('jTel').value.replace(/\D/g, '');
      setErr('jName', name ? '' : 'Escribe tu nombre.'); if (!name) first = $('jName');
      const me = !mail.value.trim() ? 'Escribe tu email.' : (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail.value.trim()) ? 'Revisa tu email: le falta la @ o el dominio.' : '');
      setErr('jMail', me); if (me) first = first || mail;
      const te = !tel ? 'Escribe tu celular.' : (!/^9\d{8}$/.test(tel) ? 'Tu celular debe tener 9 dígitos y empezar con 9.' : '');
      setErr('jTel', te); if (te) first = first || $('jTel');
      const ce = $('jOk').checked ? '' : 'Marca la casilla para poder enviarte tu código.';
      $('jOkErr').textContent = ce; if (ce) first = first || $('jOk');
      if (first) { e.preventDefault(); first.focus(); return; }
      $('jTelFull').value = 'Celular: +51' + tel;
      ls.set('thdb-joined', '1');
    });
    const done = modal.querySelector('[data-done]');
    if (done) {
      ls.set('thdb-joined', '1');
      applyCode(CODE);
      if (location.hash === '#joinForm' || /customer_posted=true/.test(location.search)) openJoin();
      $('copyCode') && ($('copyCode').onclick = async () => {
        const b = $('copyCode');
        try { await navigator.clipboard.writeText(CODE); b.textContent = 'Copiado'; } catch (err) { b.textContent = CODE; }
        setTimeout(() => (b.textContent = 'Copiar'), 2000);
      });
      $('jDone') && ($('jDone').onclick = () => modal.close());
    }
    if (window.THDB_POPUP !== false && !ls.get('thdb-club-seen') && !ls.get('thdb-joined') && !done) {
      setTimeout(() => { if (!($('drawer') && $('drawer').classList.contains('open')) && !document.querySelector('dialog[open]')) openJoin(); }, 15000);
    }
  }

  /* ---------- catálogo: búsqueda, filtros y orden ---------- */
  const grid = $('solGrid');
  if (grid) {
    const cards = [...grid.querySelectorAll('[data-card]')];
    cards.forEach((c, i) => (c.dataset.i = i));
    const params = new URLSearchParams(location.search);
    const F = { q: '', f: params.get('f') === 'pol' ? 'pol' : 'all', s: 'rel' };
    const apply = () => {
      let shown = 0;
      cards.forEach((c) => {
        const p = +c.dataset.price;
        let ok = !F.q || c.dataset.q.includes(F.q.toLowerCase());
        if (ok && F.f === 'lt150') ok = p <= 150;
        if (ok && F.f === '150-220') ok = p > 150 && p <= 220;
        if (ok && F.f === 'gt220') ok = p > 220;
        if (ok && F.f === 'pol') ok = c.dataset.pol === '1';
        if (ok && F.f === 'colors') ok = c.dataset.multi === '1';
        c.hidden = !ok; if (ok) shown++;
      });
      const sorted = [...cards].sort((a, b) => F.s === 'asc' ? a.dataset.price - b.dataset.price : F.s === 'desc' ? b.dataset.price - a.dataset.price : a.dataset.i - b.dataset.i);
      sorted.forEach((c) => grid.appendChild(c));
      $('count').textContent = `${shown} ${shown === 1 ? 'modelo' : 'modelos'}`;
      $('solEmpty').hidden = shown > 0;
      document.querySelectorAll('.chips [data-f]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.f === F.f));
    };
    $('q').addEventListener('input', (e) => { F.q = e.target.value.trim(); apply(); });
    $('sort').addEventListener('change', (e) => { F.s = e.target.value; apply(); });
    document.querySelectorAll('[data-f]').forEach((b) => b.addEventListener('click', () => { F.f = b.dataset.f; apply(); }));
    apply();
  }

  /* ---------- ficha de producto ---------- */
  const pj = $('pjson');
  if (pj) {
    const P = JSON.parse(pj.textContent);
    const form = $('pform'), vid = form.querySelector('[data-vid]');
    const gal = $('gal'), dots = $('gdots');
    let cur = P.variants.find((v) => v.id == vid.value) || P.variants[0];
    const mkDots = () => {
      const vis = [...gal.children].filter((s) => !s.hidden);
      dots.innerHTML = vis.length > 1 ? vis.map((_, i) => `<i class="${i ? '' : 'on'}"></i>`).join('') : '';
    };
    gal.addEventListener('scroll', () => {
      const first = [...gal.children].find((s) => !s.hidden); if (!first) return;
      const w = first.getBoundingClientRect().width + 10, i = Math.round(gal.scrollLeft / w);
      [...dots.children].forEach((d, j) => (d.className = j === i ? 'on' : ''));
    }, { passive: true });
    const sync = () => {
      vid.value = cur.id;
      $('vname') && ($('vname').textContent = cur.title);
      [...gal.children].forEach((s) => { const o = s.dataset.owner; s.hidden = !!o && o != cur.id; });
      gal.scrollLeft = 0; mkDots();
      const st = form.querySelector('[data-stock]');
      st.innerHTML = !cur.available ? '<i></i>Agotado' : cur.pre ? `<i style="background:var(--green)"></i>Preventa · ${esc(PRE)}` : (cur.tracked && cur.qty === 1 ? '<i style="background:var(--green)"></i>Última unidad' : '<i style="background:var(--green)"></i>Disponible');
      const inCart = cart && cart.items.some((it) => it.variant_id === cur.id);
      document.querySelectorAll('[data-addcur],[data-buynow],[data-addbar]').forEach((b) => { b.disabled = !cur.available; });
      document.querySelectorAll('[data-addcur],[data-addbar]').forEach((b) => { b.textContent = !cur.available ? 'Agotado' : (inCart ? 'En tu bolsa · Ver' : cur.pre ? 'Agregar en preventa' : 'Agregar a la bolsa'); });
      if (cur.pre && cur.available && !inCart) document.querySelectorAll('[data-addbar]').forEach((b) => { b.textContent = 'Comprar en preventa'; });
      document.querySelectorAll('[data-buynow]').forEach((b) => { b.textContent = cur.pre ? 'Comprar en preventa' : 'Comprar ahora'; });
      document.querySelectorAll('[data-prerow]').forEach((r) => { r.hidden = !cur.pre; });
    };
    form.querySelectorAll('input[name=v]').forEach((r) => r.addEventListener('change', () => { cur = P.variants.find((v) => v.id == r.value); sync(); }));
    const inCart = () => cart && cart.items.some((it) => it.variant_id === cur.id);
    const addCur = async (btn, open) => { if (inCart()) { openBag(); return; } const ok = await addVariant(cur.id, btn, cur.img, open, cur.pre); if (ok) sync(); };
    form.addEventListener('submit', (e) => { e.preventDefault(); addCur(form.querySelector('[data-addcur]'), true); });
    document.querySelector('[data-addbar]') && document.querySelector('[data-addbar]').addEventListener('click', (e) => addCur(e.currentTarget, true));
    document.querySelector('[data-buynow]') && document.querySelector('[data-buynow]').addEventListener('click', async (e) => {
      if (!inCart()) { const ok = await addVariant(cur.id, e.currentTarget, cur.img, false, cur.pre); if (!ok) return; }
      const c = code(); location.href = c ? `/discount/${encodeURIComponent(c)}?redirect=/checkout` : '/checkout';
    });
    fetchCart().then(sync);
    sync();
  }

  /* ---------- revelado al hacer scroll ---------- */
  const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -10% 0px' });
  document.querySelectorAll('.rv').forEach((el) => io.observe(el));

  if (!pj) fetchCart();
})();


/* ---------- Mi cuenta: detalle de pedido ---------- */
document.querySelectorAll('[data-otoggle]').forEach((b) => b.addEventListener('click', () => {
  const d = b.parentElement.querySelector('.odet'); if (!d) return;
  const open = d.hidden; d.hidden = !open; b.setAttribute('aria-expanded', open); b.textContent = open ? 'Ocultar detalle' : 'Ver detalle';
}));

/* ---------- Libro de Reclamaciones ---------- */
(() => {
  const root = document.querySelector('[data-lr]'); if (!root) return;
  const K = 'thdb-lr-last';
  const f = document.getElementById('lrForm');
  const minor = document.getElementById('lrMinor');
  minor && minor.addEventListener('change', () => { document.getElementById('lrParentBox').hidden = !minor.checked; });
  if (f && document.getElementById('lrName')) {
    f.addEventListener('submit', (e) => {
      const req = [...f.querySelectorAll('[required]')];
      const bad = req.find((el) => !String(el.value || '').trim());
      const mail = document.getElementById('lrMail');
      const err = document.getElementById('lrErr');
      let msg = '';
      if (bad) msg = 'Completa los campos marcados con *.';
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail.value.trim())) msg = 'Revisa tu email.';
      else if (minor.checked && !document.getElementById('lrParent').value.trim()) msg = 'Indica los datos de tu padre, madre o apoderado.';
      else if (!document.getElementById('lrOk').checked) msg = 'Marca la declaración para registrar la hoja.';
      if (msg) { e.preventDefault(); err.textContent = msg; (bad || mail).focus(); return; }
      const d = new Date(), p = (n) => String(n).padStart(2, '0');
      const num = `LR-${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}-${p(d.getHours())}${p(d.getMinutes())}${p(d.getSeconds())}`;
      const date = d.toLocaleString('es-PE');
      document.getElementById('lrNum').value = num;
      document.getElementById('lrDate').value = date;
      const data = { numero: num, fecha: date };
      new FormData(f).forEach((v, k) => { const m = k.match(/^contact\[(.+)\]$/); if (m) data[m[1] === 'body' ? 'Detalle' : m[1]] = v; });
      try { sessionStorage.setItem(K, JSON.stringify(data)); } catch (x) {}
      const hook = root.dataset.hook;
      if (hook) { try { navigator.sendBeacon(hook, new Blob([JSON.stringify(data)], { type: 'application/json' })); } catch (x) {} }
    });
  }
  const done = root.querySelector('[data-lr-done]');
  if (done) {
    let data = null; try { data = JSON.parse(sessionStorage.getItem(K)); } catch (x) {}
    const box = document.getElementById('lrCopy');
    if (data && box) {
      const skip = ['Proveedor'];
      box.textContent = `Hoja de reclamación Nº ${data.numero}\nFecha: ${data.fecha}\n${root.querySelector('.lr-prov').innerText.replace(/\n+/g, ' · ')}\n\n` +
        Object.entries(data).filter(([k]) => !['numero', 'fecha', ...skip].includes(k) && k !== 'form_type' && k !== 'utf8').map(([k, v]) => `${k === 'name' ? 'Nombre' : k === 'email' ? 'Email' : k === 'phone' ? 'Teléfono' : k}: ${v}`).join('\n');
    } else if (box) { box.textContent = 'Tu hoja quedó registrada. Revisa tu correo para la constancia.'; }
    document.querySelector('[data-lr-print]').addEventListener('click', () => window.print());
  }
})();
